import { defineAsyncComponent } from 'vue'
import { TPageLayoutOptions, TPageRequestOptions } from '~/types/page-types'

const belongsToFields = [
  'belongs_to.*',
  'belongs_to.item.id',
  'belongs_to.item.slug',
  'belongs_to.item.title',
  'belongs_to.item.domain.color.name'
]

const domainFields = [
  'domain.*.*'
]

const defaultPageFieldset = [
  '*', 'seo.*', 'content.*'
]

export const pageDefinitions: Record<string, TPageRequestOptions & TPageLayoutOptions> = {
  articles: { // this is the archive page
    singleton: false,
    fields: [...defaultPageFieldset, ...belongsToFields, 'main_image.*'],
    showProgressBar: false,
    card: {
      size: 'small',
      component: defineAsyncComponent(() =>
        import('~/components/cards/ArchiveCard.vue')
      )
    }
  },
  home_page: {
    singleton: true,
    fields: [...defaultPageFieldset,
      'hero_items.*',
      'hero_items.belongs_to.*',
      'hero_items.belongs_to.item.id',
      'hero_items.belongs_to.item.slug',
      'hero_items.belongs_to.item.title',
      'hero_items.page.collection',
      'hero_items.page.item.id',
      'hero_items.page.item.slug',
      'hero_items.page.item.belongs_to.*',
      'hero_items.page.item.belongs_to.item.id',
      'hero_items.page.item.belongs_to.item.slug',
      'hero_items.page.item.belongs_to.item.title'
    ],
    showProgressBar: false
  },
  vacancy_overview_page: {
    singleton: false,
    fields: [...defaultPageFieldset],
    showProgressBar: false
  },
  // overview pages
  overview_page: {
    singleton: false,
    fields: [...defaultPageFieldset, ...domainFields],
    showProgressBar: false,
    card: {
      size: 'small',
      component: defineAsyncComponent(() =>
        import('~/components/cards/OverviewCard.vue')
      )
    }
  },
  people_page: {
    singleton: false,
    fields: [...defaultPageFieldset, 'persons.*', ...belongsToFields],
    showProgressBar: false
  },
  person_page: {
    singleton: false,
    fields: [...defaultPageFieldset, ...domainFields, ...belongsToFields],
    showProgressBar: false,
    card: {
      size: 'small',
      component: defineAsyncComponent(() =>
        import('~/components/cards/PersonCard.vue')
      )
    }
  },
  program_page: {
    singleton: false,
    fields: [...defaultPageFieldset, ...domainFields, ...belongsToFields],
    showProgressBar: false,
    card: {
      size: 'small',
      component: defineAsyncComponent(() =>
        import('~/components/cards/ProgramCard.vue')
      )
    }
  },
  // detail pages
  article_page: {
    singleton: false,
    fields: [...defaultPageFieldset, ...domainFields, ...belongsToFields],
    showProgressBar: true,
    card: {
      size: 'small',
      component: defineAsyncComponent(() =>
        import('~/components/cards/ArticleCard.vue')
      )
    }
  },
  content_page: {
    singleton: false,
    fields: [...defaultPageFieldset, ...domainFields, ...belongsToFields],
    showProgressBar: false,
    card: {
      size: 'large',
      component: defineAsyncComponent(() =>
        import('~/components/cards/ContentCard.vue')
      )
    }
  },
  longread_page: {
    singleton: false,
    fields: [...defaultPageFieldset, ...domainFields, ...belongsToFields],
    showProgressBar: false,
    card: {
      size: 'large',
      component: defineAsyncComponent(() =>
        import('~/components/cards/LongreadCard.vue')
      )
    }
  },
  short_page: {
    singleton: false,
    fields: [...defaultPageFieldset, ...domainFields, ...belongsToFields],
    showProgressBar: false,
    card: {
      size: 'large',
      component: defineAsyncComponent(() =>
        import('~/components/cards/ShortCard.vue')
      )
    }
  },
  story_page: {
    singleton: false,
    fields: [...defaultPageFieldset, ...domainFields, ...belongsToFields],
    showProgressBar: false,
    card: {
      size: 'large',
      component: defineAsyncComponent(() =>
        import('~/components/cards/StoryCard.vue')
      )
    }
  },
  vacancy_page: {
    singleton: false,
    fields: [...defaultPageFieldset, 'afas_vacancy_id', 'is_internship'],
    showProgressBar: false,
    card: {
      size: 'large',
      component: defineAsyncComponent(() =>
        import('~/components/cards/ContentCard.vue')
      )
    }
  },
  video_page: {
    singleton: false,
    fields: [...defaultPageFieldset, ...domainFields, ...belongsToFields],
    showProgressBar: false,
    card: {
      size: 'small',
      component: defineAsyncComponent(() =>
        import('~/components/cards/VideoCard.vue')
      )
    }
  }
}
